import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { TransferOfChargeBulkEditCriteria } from "domain/entity/TransferOfCharge/TransferOfChargeBulkEditCriteria";
import { TransferOfChargeSearchCriteria } from "domain/entity/TransferOfCharge/TransferOfChargeSearchCriteria";
import { axiosPostData } from "../axios/AxiosBasicImpl";
import chargeAxiosInstance from "../axios/chargeAxiosInstance";
import { TransferOfChargeRepository } from "./TransferOfChargeRepo";

export const TransferOfChargeRepoImpl = (): TransferOfChargeRepository => {

    const getEntities = async (criteria: TransferOfChargeSearchCriteria): Promise<ResponseEntity> => {
        const url = '/v1/transferOfCharge';
        return await axiosPostData(chargeAxiosInstance, `${url}`, criteria);
    }

    const onSave = async (criteria: TransferOfChargeBulkEditCriteria): Promise<ResponseEntity> => {
        const url = '/v1/transferOfChargeSave';
        return await axiosPostData(chargeAxiosInstance, `${url}`, criteria);
    }

    const onConfirmAndSubmit = async (ids: number[]): Promise<ResponseEntity> => {
        const url = '/v1/transferOfChargeConfirmAndSubmit';
        return await axiosPostData(chargeAxiosInstance, `${url}`, ids);
    }

    const onApply = async (ids: number[]): Promise<ResponseEntity> => {
        const url = '/v1/transferOfChargeApply';
        return await axiosPostData(chargeAxiosInstance, `${url}`, ids);
    }


    return {
        getEntities: getEntities,
        onSave: onSave,
        onApply: onApply,
        onConfirmAndSubmit: onConfirmAndSubmit,
    }
}